import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

import "../../../assets/css/gcadmin/disputespage/AdminDisputesPage.css";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

/* ── Chat Modal — now backed by real API ── */
const ChatModal = ({ item, onClose, baseUrl }) => {
  const [visible, setVisible] = useState(false);
  const [msg, setMsg] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const { authToken } = useContext(AppContext);

  useEffect(() => {
  setTimeout(() => setVisible(true), 30);

  fetchMessages(true); 

  const interval = setInterval(() => {
    fetchMessages(false); 
  }, 4000);

  return () => clearInterval(interval);
}, []);
  

const fetchMessages = (showLoader = false) => {
  if (showLoader) setLoading(true);

  const formData = new FormData();
  formData.append("lbdispute_id", item.id);

  axios
    .post(`${baseUrl}/admin/chat/fetchAllChats`, formData,
      { headers: {  "Authorization": `Bearer ${authToken}` } }
    )
    .then((res) => {
      setMessages(res.data.chats || []);
    })
    .catch((error) => {
      console.log("Fetch chat error:", error.response?.data || error);
    })
    .finally(() => {
      if (showLoader) setLoading(false);
    });
};

  const handleClose = () => {
  setVisible(false);
  setTimeout(onClose, 260);
};

const send = () => {
  if (!msg.trim() || sending) return;

  setSending(true);

  const formData = new FormData();
  formData.append("lbdispute_id", item.id);
  formData.append("message", msg.trim());

  axios
    .post(`${baseUrl}/admin/chat/store`, formData,
      { headers: {  "Authorization": `Bearer ${authToken}` } }
    )
    .then((res) => {
      setMessages((p) => [...p, res.data.chat]);
      setMsg("");
    })
    .catch((error) => {
      console.log("Send chat error:", error.response?.data || error);
      Swal.fire("Error", "Message could not be sent", "error");
    })
    .finally(() => {
      setSending(false);
    });
};

  return (
    <div className={`gcAdmin-dsp-backdrop ${visible ? "gcAdmin-dsp-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdmin-dsp-modal ${visible ? "gcAdmin-dsp-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdmin-dsp-modal-header">
          <div>
            <h5 className="gcAdmin-dsp-modal-title">Dispute Chat</h5>
            <p className="gcAdmin-dsp-modal-sub">#{item.id} • {item.subject}</p>
          </div>
          <button className="gcAdmin-dsp-modal-close" onClick={handleClose}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="gcAdmin-dsp-chat-body">
          {loading && (
            <p style={{ textAlign: "center", padding: "10px" }}>Loading messages...</p>
          )}

          {!loading && messages.length === 0 && (
            <p style={{ textAlign: "center", padding: "10px", opacity: 0.6 }}>
              No messages yet.
            </p>
          )}

          {/* sender comes from DB now: "student", "teacher", or "admin".
              Anything that isn't admin's own message is styled as the
              "other side" of the conversation. */}
          {!loading && messages.map((m) => (
            <div
              key={m.id}
              className={`gcAdmin-dsp-msg gcAdmin-dsp-msg--${m.sender === "admin" ? "admin" : "user"}`}
            >
              <p className="gcAdmin-dsp-msg-text">{m.message}</p>
              <span className="gcAdmin-dsp-msg-time">
                {new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
              </span>
            </div>
          ))}
        </div>

        <div className="gcAdmin-dsp-chat-input">
          <input
            className="gcAdmin-dsp-input"
            placeholder="Type a message..."
            value={msg}
            onChange={e => setMsg(e.target.value)}
            onKeyDown={e => e.key === "Enter" && send()}
          />
          <button className="gcAdmin-dsp-send-btn" onClick={send} disabled={sending}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── Resolve Confirm Modal (unchanged) ── */
const ResolveModal = ({ item, onClose, onConfirm }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 260); };

  return (
    <div className={`gcAdmin-dsp-backdrop ${visible ? "gcAdmin-dsp-backdrop--in" : ""}`} onClick={handleClose}>
      <div className={`gcAdmin-dsp-modal gcAdmin-dsp-modal--sm ${visible ? "gcAdmin-dsp-modal--in" : ""}`} onClick={e => e.stopPropagation()}>
        <div className="gcAdmin-dsp-resolve-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#0f8a65" strokeWidth="1.8"/>
            <path d="M8 12l3 3 5-5" stroke="#0f8a65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h5 className="gcAdmin-dsp-resolve-title">Resolve Dispute?</h5>
        <p className="gcAdmin-dsp-resolve-msg">
          Mark <strong>#{item.id}</strong> as resolved? This action will close the dispute.
        </p>
        <div className="gcAdmin-dsp-resolve-actions">
          <button className="gcAdmin-dsp-cancel-btn" onClick={handleClose}>Cancel</button>
          <button className="gcAdmin-dsp-confirm-btn" onClick={() => { onConfirm(item.id); handleClose(); }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Resolve
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── Main Page ── */
const AdminDisputesPage = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [disputes, setDisputes]       = useState([]);
  const [search, setSearch]           = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  // ✅ Default to "student" so the Students tab is active on page load,
  // matching the toggle UI (Students / Staff).
  const [roleFilter, setRoleFilter]   = useState("student");
  const [chatItem, setChatItem]       = useState(null);
  const [resolveItem, setResolveItem] = useState(null);
  const [loading, setLoading]         = useState(false);
  const [pageIn, setPageIn]           = useState(false);
  const [rowVisible, setRowVisible]   = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // ✅ pagination state

  useEffect(() => { setTimeout(() => setPageIn(true), 60); }, []);

  /* ─────────────────────────────
     Fetch All Disputes (Admin)
  ───────────────────────────── */
  const fetchAllDisputes = () => {
  setLoading(true);

  axios
    .get(`${baseUrl}/admin/disputes/fetchAllDisputes`,
      { headers: {  "Authorization": `Bearer ${authToken}` } }
    )
    .then((res) => {
      setDisputes(res.data.disputes || []);
    })
    .catch((error) => {
      console.log(error);
      Swal.fire("Error", "Failed to fetch disputes", "error");
    })
    .finally(() => {
      setLoading(false);
    });
};
  useEffect(() => { fetchAllDisputes(); }, []);

  /* ─────────────────────────────
     Resolve Dispute
  ───────────────────────────── */
 const handleResolve = (id) => {
  const formData = new FormData();
  formData.append("id", id);

  axios
    .post(`${baseUrl}/admin/disputes/resolve`, formData,
      { headers: {  "Authorization": `Bearer ${authToken}` } }
    )
    .then((res) => {

      setDisputes((prev) =>
        prev.map((d) =>
          d.id === id ? { ...d, status: "resolved" } : d
        )
      );

      Swal.fire("Success", "Dispute resolved successfully", "success");
    })
    .catch((error) => {
      console.log(error);
      Swal.fire("Error", "Failed to resolve dispute", "error");
    });
};

  /* ─────────────────────────────
     Filter Logic
  ───────────────────────────── */
  const filtered = disputes.filter(d => {
    const matchStatus = statusFilter === "All" || d.status?.toLowerCase() === statusFilter.toLowerCase();
    const matchRole   = roleFilter   === "All" || d.raisedby?.toLowerCase() === roleFilter.toLowerCase();
    const q = search.toLowerCase();
    const matchSearch = !q ||
      d.subject?.toLowerCase().includes(q) ||
      d.category?.toLowerCase().includes(q) ||
      String(d.id).includes(q);
    return matchStatus && matchRole && matchSearch;
  });

  /* ── Paginated slice (jo table ko jayega) ── */
  const paginatedDisputes = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Search/filter change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [search, statusFilter, roleFilter]);

  useEffect(() => {
    setRowVisible([]);
    paginatedDisputes.forEach((_, i) => {
      setTimeout(() => {
        setRowVisible(prev => { const n = [...prev]; n[i] = true; return n; });
      }, i * 70);
    });
  // eslint-disable-next-line
  }, [search, statusFilter, roleFilter, disputes, currentPage]);

  const STATUS_FILTERS = ["All", "Open", "Resolved"];

  return (
    <div className={`gcAdmin-dsp-page ${pageIn ? "gcAdmin-dsp-page--in" : ""}`}>
      <Container fluid className="gcAdmin-dsp-container">

        <h2 className="gcAdmin-dsp-title">Disputes &amp; Support</h2>

        {/* ✅ Students / Staff toggle — replaces the old role <select> */}
        <div className="gcAdmin-dsp-roletoggle">
          <button
            className={`gcAdmin-dsp-roletoggle__btn ${roleFilter === "student" ? "gcAdmin-dsp-roletoggle__btn--active" : ""}`}
            onClick={() => setRoleFilter("student")}
          >
            Students
          </button>
          <button
            className={`gcAdmin-dsp-roletoggle__btn ${roleFilter === "teacher" ? "gcAdmin-dsp-roletoggle__btn--active" : ""}`}
            onClick={() => setRoleFilter("teacher")}
          >
            Staff
          </button>
        </div>

        <div className="gcAdmin-dsp-controls">

          <div className="gcAdmin-dsp-search-wrap">
            <input
              className="gcAdmin-dsp-search"
              type="text"
              placeholder="Search disputes..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <div className="gcAdmin-dsp-filter-wrap">
            <select
              className="gcAdmin-dsp-filter"
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
            >
              {STATUS_FILTERS.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
            <svg className="gcAdmin-dsp-filter-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

        </div>

        <div className="gcAdmin-dsp-table-wrap">
          {loading ? (
            <Loader message="Disputes loading, please wait..." />
          ) : (
            <>
              <table className="gcAdmin-dsp-table">
                <thead>
                  <tr>
                    <th className="gcAdmin-dsp-th">ID</th>
                    <th className="gcAdmin-dsp-th">Raised By</th>
                    <th className="gcAdmin-dsp-th">Subject</th>
                    <th className="gcAdmin-dsp-th">Category</th>
                    <th className="gcAdmin-dsp-th">Date</th>
                    <th className="gcAdmin-dsp-th">Status</th>
                    <th className="gcAdmin-dsp-th">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedDisputes.map((item, i) => (
                    <tr
                      key={item.id}
                      className={`gcAdmin-dsp-tr ${rowVisible[i] ? "gcAdmin-dsp-tr--in" : ""}`}
                      style={{ transitionDelay: `${i * 0.05}s` }}
                    >
                     <td className="gcAdmin-dsp-td">
    <span className="gcAdmin-dsp-id">#{item.id}</span>
  </td>

  <td className="gcAdmin-dsp-td">
    <p className="gcAdmin-dsp-name">
      {item.raisedby === "teacher"
        ? (item.lbteacher?.name || item.lbteacher?.fullName || `Teacher #${item.lbteacher_id}`)
        : (item.lbstudent?.fullName || item.lbstudent?.name || `Student #${item.lbstudent_id}`)}
    </p>
    <p className="gcAdmin-dsp-role">
      {item.raisedby === "teacher" ? "Staff" : "Student"}
    </p>
  </td>

                      <td className="gcAdmin-dsp-td">
                        <span className="gcAdmin-dsp-subject">{item.subject}</span>
                      </td>

                      <td className="gcAdmin-dsp-td gcAdmin-dsp-td--book">
                        {item.category}
                      </td>

                      <td className="gcAdmin-dsp-td gcAdmin-dsp-td--date">
                        {new Date(item.created_at).toLocaleDateString()}
                      </td>

                      <td className="gcAdmin-dsp-td">
                        <span className={`gcAdmin-dsp-badge gcAdmin-dsp-badge--${(item.status || "open").toLowerCase()}`}>
                          {item.status || "Open"}
                        </span>
                      </td>

                      <td className="gcAdmin-dsp-td">
                        <div className="gcAdmin-dsp-actions">
                          <button
                            className="gcAdmin-dsp-btn gcAdmin-dsp-btn--chat"
                            onClick={() => setChatItem(item)}
                            title="Chat"
                          >
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                            </svg>
                          </button>

                          {(item.status || "open").toLowerCase() === "open" && (
                            <button
                              className="gcAdmin-dsp-btn gcAdmin-dsp-btn--resolve"
                              onClick={() => setResolveItem(item)}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.8"/>
                                <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              Resolve
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {paginatedDisputes.length === 0 && (
                    <tr>
                      <td colSpan={7} className="gcAdmin-dsp-td gcAdmin-dsp-td--empty">
                        No disputes found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalItems={filtered.length}
                itemsPerPage={ITEMS_PER_PAGE}
                onPageChange={setCurrentPage}
              />
            </>
          )}
        </div>

      </Container>

      {chatItem    && <ChatModal    item={chatItem}    onClose={() => setChatItem(null)} baseUrl={baseUrl} />}
      {resolveItem && <ResolveModal item={resolveItem} onClose={() => setResolveItem(null)} onConfirm={handleResolve} />}
    </div>
  );
};

export default AdminDisputesPage;